module.exports = __webpack_public_path__ + "AdobeStock_593430244_crop1_2.png?f8dbf3991104fe74a4efa63316a39588";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newborn/AdobeStock_593430244_crop1_2.png
// module id = 163
// module chunks = 0